import { Layout } from '../components/layout/Layout';
import { HeroSlider } from '../components/home/HeroSlider';
import { FeaturedPackages } from '../components/home/FeaturedPackages';
import { WhyChooseUs } from '../components/home/WhyChooseUs';
import { TestimonialsSlider } from '../components/home/TestimonialsSlider';
import { QuickEnquiry } from '../components/home/QuickEnquiry';
import { Newsletter } from '../components/home/Newsletter';
import { PopularDestinations } from '../components/home/PopularDestinations';
import { CTASection } from '../components/home/CTASection';
import { 
  SEO, 
  OrganizationSchema, 
  WebsiteSchema, 
  LocalBusinessSchema 
} from '../components/seo';

export default function HomePage() {
  return (
    <Layout>
      {/* SEO Meta Tags */}
      <SEO 
        title="Home"
        description="Discover unforgettable travel experiences with NYRAV Tours and Travels. Book domestic and international tour packages, honeymoon trips, corporate travel, and custom adventures."
        keywords="tours, travels, india, tour packages, honeymoon packages, adventure tours, family vacation, travel agency"
      />
      
      {/* JSON-LD Structured Data */}
      <OrganizationSchema />
      <WebsiteSchema />
      <LocalBusinessSchema />

      {/* Hero Slider with Auto-play */}
      <HeroSlider />

      {/* Why Choose Us Section */}
      <WhyChooseUs />

      {/* Featured Tour Packages */}
      <FeaturedPackages />

      {/* Popular Destinations */}
      <PopularDestinations />

      {/* Testimonials Slider */}
      <TestimonialsSlider />

      {/* Newsletter Section */}
      <Newsletter />

      {/* CTA Section */}
      <CTASection />

      {/* Floating Quick Enquiry Form */}
      <QuickEnquiry />
    </Layout>
  );
}
